import { apiService } from './apiService';

export interface SearchResultProject {
  id: number;
  name: string;
  reference: string;
  client: {
    name: string;
  };
}

export interface SearchResponse {
  projects: SearchResultProject[];
}

export const searchService = {
  async globalSearch(text: string): Promise<{ success: boolean; data?: SearchResponse; message?: string }> {
    try {
      const response = await apiService.search(text);
      
      if (response.success) {
        return { success: true, data: response.data };
      } else {
        return { success: false, message: response.message || 'Search failed' };
      }
    } catch (error) {
      console.error('Search API error:', error);
      return { success: false, message: 'Network error occurred' };
    }
  },
};
